import { render } from "./PageDepoimentosApiGoogle.vue?vue&type=template&id=0a1dc39b&scoped=true"
import script from "./PageDepoimentosApiGoogle.vue?vue&type=script&lang=js"
export * from "./PageDepoimentosApiGoogle.vue?vue&type=script&lang=js"

import "./PageDepoimentosApiGoogle.vue?vue&type=style&index=0&id=0a1dc39b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1dc39b"]])

export default __exports__